/* @flow */
import navigation from 'services/NavigationService';

import { apiService } from 'services/ServiceRegistry';

import { activities } from 'components/Activity/ActivityData.js';

import Form from '../_.extend';

export const makeFields: Function = (accountData: Object, t: Function) => {
  return [
    {
      name: 'accountDetail',
      label: t('general:accounts.labels.details'),
      fields: [
        {
          name: 'accountName',
          label: t('general:trading_accounts.labels.name'),
          rules: 'required|string',
          value: accountData.name,
        },
        {
          name: 'accountNumber',
          label: t('general:trading_accounts.labels.number'),
          rules: 'string',
          value: accountData.account_no,
        },
        {
          name: 'accountPrefix',
          label: t('general:trading_accounts.labels.prefix'),
          rules: 'string',
          value: accountData.asset_request_prefix,
        },
      ],
    },
    {
      name: 'accountRegion',
      label: t('general:accounts.labels.region'),
      fields: [
        {
          name: 'region_id',
          label: t('general:region'),
          rules: 'string',
          value: accountData && accountData.region ? accountData.region.name : null,
          extra: {
            selectID: accountData && accountData.region ? accountData.region.id : null,
          },
        },
      ],
    },
    {
      name: 'accountPreferences',
      label: t('general:accounts.labels.preferences'),
      fields: [
        {
          name: 'saleConsignment',
          label: t('general:assets.labels.allow_sale_consignment'),
          rules: 'boolean',
          value: accountData.sale_consignment,
        },
        {
          name: 'subrentalProgram',
          label: t('general:assets.labels.allow_sub_rental_program'),
          rules: 'boolean',
          value: accountData.subrental_program,
        },
        {
          name: 'newAssetRequest',
          label: t('general:assets.labels.allow_new_asset_request'),
          rules: 'boolean',
          value: accountData.asset_request_form_enabled,
        },
        {
          name: 'newAssetRequestEmail',
          label: t('general:assets.labels.asset_request_form_email'),
          rules: 'string|email',
          value: accountData.asset_request_email_address,
        },
        {
          name: 'newRushAssetRequest',
          label: t('general:assets.labels.allow_new_rush_asset_request'),
          rules: 'boolean',
          value: accountData.is_rush_asset_request_form_customer,
        },
        {
          name: 'newRushAssetRequestEmail',
          label: t('general:assets.labels.rush_asset_request_form_email'),
          rules: 'string|email',
          value: accountData.rush_asset_request_email_address,
        },
        {
          name: 'newLicenseRequest',
          label: t('general:assets.labels.allow_new_license_request'),
          rules: 'boolean',
          value: accountData.license_request_form_enabled,
        },
        {
          name: 'newLicenseRequestEmail',
          label: t('general:assets.labels.license_request_form_email'),
          rules: 'string|email',
          value: accountData.license_request_email_address,
        },
        {
          name: 'is_caas_customer',
          label: t('general:caas.labels.is_caas_customer'),
          rules: 'boolean',
          value: accountData.is_caas_customer || false,
        },
        {
          name: 'is_caas_active',
          label: t('general:caas.labels.is_caas_active'),
          rules: 'boolean',
          value: accountData.is_caas_active || false,
        },
        {
          name: 'caas_customer_po',
          label: t('general:caas.labels.caas_customer_po'),
          rules: 'required_if:accountPreferences.is_caas_active,true|string|max:64',
          value: accountData.caas_customer_po,
        },
        {
          name: 'erp_order_id',
          label: t('general:caas.labels.erp_order_id'),
          rules: 'required_if:accountPreferences.is_caas_active,true|string|max:64',
          value: accountData.erp_order_id,
        },
      ],
    },
    {
      name: 'assetCustomFields',
      label: t('general:assets.custom_fields'),
      fields: [
        {
          name: 'customLabel1',
          label: t('general:labels.custom_field_label', { fieldNumber: 1 }),
          rules: 'string',
          value:
            accountData.custom_fields &&
            (accountData.custom_fields[0] && accountData.custom_fields[0].key),
        },
        {
          name: 'customHelp1',
          label: t('general:labels.custom_field_help', { fieldNumber: 1 }),
          rules: 'string',
          value:
            accountData.custom_fields &&
            (accountData.custom_fields[0] && accountData.custom_fields[0].value),
        },
        {
          name: 'customLabel2',
          label: t('general:labels.custom_field_label', { fieldNumber: 2 }),
          rules: 'string',
          value:
            accountData.custom_fields &&
            (accountData.custom_fields[1] && accountData.custom_fields[1].key),
        },
        {
          name: 'customHelp2',
          label: t('general:labels.custom_field_help', { fieldNumber: 2 }),
          rules: 'string',
          value:
            accountData.custom_fields &&
            (accountData.custom_fields[1] && accountData.custom_fields[1].value),
        },
        {
          name: 'customLabel3',
          label: t('general:labels.custom_field_label', { fieldNumber: 3 }),
          rules: 'string',
          value:
            accountData.custom_fields &&
            (accountData.custom_fields[2] && accountData.custom_fields[2].key),
        },
        {
          name: 'customHelp3',
          label: t('general:labels.custom_field_help', { fieldNumber: 3 }),
          rules: 'string',
          value:
            accountData.custom_fields &&
            (accountData.custom_fields[2] && accountData.custom_fields[2].value),
        },
        {
          name: 'customLabel4',
          label: t('general:labels.custom_field_label', { fieldNumber: 4 }),
          rules: 'string',
          value:
            accountData.custom_fields &&
            (accountData.custom_fields[3] && accountData.custom_fields[3].key),
        },
        {
          name: 'customHelp4',
          label: t('general:labels.custom_field_help', { fieldNumber: 4 }),
          rules: 'string',
          value:
            accountData.custom_fields &&
            (accountData.custom_fields[3] && accountData.custom_fields[3].value),
        },
      ],
    },
  ];
};

class AccountFormCreate extends Form {}

class AccountFormEdit extends Form {}

export const accountCreate: Function = (fields: Array<*>, localState: Object, t: Function) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const { accountName, accountNumber, accountPrefix }: Object = form.values().accountDetail;

      const {
        saleConsignment,
        subrentalProgram,
        newAssetRequest,
        newAssetRequestEmail,
        newRushAssetRequest,
        newRushAssetRequestEmail,
        newLicenseRequest,
        newLicenseRequestEmail,
      }: Object = form.values().accountPreferences;

      const {
        customLabel1,
        customHelp1,
        customLabel2,
        customHelp2,
        customLabel3,
        customHelp3,
        customLabel4,
        customHelp4,
      }: Object = form.values().assetCustomFields;

      apiService
        .createResource('accounts', {
          activity_tag: activities.createdAccount.tag, // eslint-disable-line camelcase
          name: accountName,
          account_no: accountNumber,
          is_enabled: true,
          region_id: form.$('accountRegion.region_id').extra.selectID,
          sale_consignment: saleConsignment || false,
          subrental_program: subrentalProgram || false,
          asset_request_form_enabled: newAssetRequest || false,
          asset_request_email_address: newAssetRequestEmail || null,
          is_rush_asset_request_form_customer: newRushAssetRequest || false,
          rush_asset_request_email_address: newRushAssetRequestEmail || null,
          license_request_form_enabled: newLicenseRequest || false,
          license_request_email_address: newLicenseRequestEmail || null,
          asset_request_prefix: accountPrefix || null,
          custom_fields: [
            { key: customLabel1, value: customHelp1 },
            { key: customLabel2, value: customHelp2 },
            { key: customLabel3, value: customHelp3 },
            { key: customLabel4, value: customHelp4 },
          ],
          ...getCaaSFields(form.values().accountPreferences),
        })
        .then((response: Object) => {
          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              navigation.replace('/accounts', { formSuccess: true });
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: Object) => {
          localState.isLoading = false;
          let errToShow =
            err && err.errors && err.errors.name && err.errors.name.length > 0
              ? err.errors.name[0]
              : '';

          if (errToShow === '') {
            errToShow =
              err && err.errors && err.errors.account_no && err.errors.account_no.length > 0
                ? err.errors.account_no[0]
                : '';
          }

          localState.responseMessage = errToShow === '' ? err && err.message : errToShow;
          localState.hasSuccess = false;
          localState.hasError = true;
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.save_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
      console.log('errors: ', form.values());
    },
  };

  return new AccountFormCreate(
    { fields },
    { hooks, name: t('general:actions.create_new_trading_account') }
  );
};

export const accountEdit: Function = (
  fields: Array<*>,
  accountData: Object,
  accountStore: Object,
  localState: Object,
  t: Function
) => {
  const hooks: Object = {
    onSuccess(form: Object) {
      localState.isLoading = true;
      localState.responseMessage = t('general:messages.saving_form');
      localState.showResponseMessage = true;
      localState.hasError = false;
      localState.hasSuccess = true;

      const { accountName, accountNumber, accountPrefix }: Object = form.values().accountDetail;

      const {
        saleConsignment,
        subrentalProgram,
        newAssetRequest,
        newAssetRequestEmail,
        newRushAssetRequest,
        newRushAssetRequestEmail,
        newLicenseRequest,
        newLicenseRequestEmail,
      }: Object = form.values().accountPreferences;

      const {
        customLabel1,
        customHelp1,
        customLabel2,
        customHelp2,
        customLabel3,
        customHelp3,
        customLabel4,
        customHelp4,
      }: Object = form.values().assetCustomFields;

      apiService
        .putResource(`accounts/${accountData.id}`, {
          activity_tag: activities.edited.tag, // eslint-disable-line camelcase
          name: accountName,
          account_no: accountNumber,
          is_enabled: true,
          region_id: form.$('accountRegion.region_id').extra.selectID,
          sale_consignment: saleConsignment || false,
          subrental_program: subrentalProgram || false,
          asset_request_form_enabled: newAssetRequest || false,
          asset_request_email_address: newAssetRequestEmail || null,
          is_rush_asset_request_form_customer: newRushAssetRequest || false,
          rush_asset_request_email_address: newRushAssetRequestEmail || null,
          license_request_form_enabled: newLicenseRequest || false,
          license_request_email_address: newLicenseRequestEmail || null,
          asset_request_prefix: accountPrefix || null,
          custom_fields: [
            { key: customLabel1, value: customHelp1 },
            { key: customLabel2, value: customHelp2 },
            { key: customLabel3, value: customHelp3 },
            { key: customLabel4, value: customHelp4 },
          ],
          ...getCaaSFields(form.values().accountPreferences),
        })
        .then((response: Object) => {
          //update Store from Response
          accountStore.resetLocations();
          accountStore.loadCompanies(accountData.id);
          accountStore.loadDetails(accountData.id, true);

          if (accountStore && accountStore.details && accountStore.details.details) {
            const details: Object = accountStore.details.details;
            details.name = response.name;
            details.sale_consignment = response.sale_consignment; // eslint-disable-line camelcase
            details.subrental_program = response.subrental_program; // eslint-disable-line camelcase
            details.custom_fields = response.custom_fields; // eslint-disable-line camelcase
          }

          localState.isLoading = false;
          localState.responseMessage = t('general:messages.save_success');

          setTimeout(() => {
            localState.showResponseMessage = false;
            /*eslint-disable max-nested-callbacks*/
            setTimeout(() => {
              // Snackbar animation 225ms
              navigation.goBack();
            }, 225);
          }, 1200);

          return response;
        })

        .catch((err: string) => {
          localState.isLoading = false;
          let errToShow =
            err && err.errors && err.errors.name && err.errors.name.length > 0
              ? err.errors.name[0]
              : '';

          if (errToShow === '') {
            errToShow =
              err && err.errors && err.errors.account_no && err.errors.account_no.length > 0
                ? err.errors.account_no[0]
                : '';
          }

          localState.responseMessage = errToShow === '' ? err && err.message : errToShow;
          localState.hasSuccess = false;
          localState.hasError = true;
          console.log(err);
        });
    },
    onError(form: Object) {
      localState.isLoading = false;
      localState.responseMessage = t('general:messages.save_error');
      localState.showResponseMessage = true;
      localState.hasSuccess = false;
      localState.hasError = true;
      console.log('errors: ', form.values());
    },
  };

  return new AccountFormEdit(
    { fields },
    { hooks, name: t('general:actions.edit_trading_account') }
  );
};

/**
 * Returns a plain object containing the CaaS values ready to be sent to
 * the store or update endpoints, when is_caas_customer is false all
 * other caas values are set to its default value, otherwise they
 * keep the current value.
 */
function getCaaSFields({ erp_order_id, is_caas_active, caas_customer_po, is_caas_customer }) {
  return {
    is_caas_customer,
    erp_order_id: is_caas_customer ? erp_order_id : null,
    is_caas_active: is_caas_customer ? is_caas_active : false,
    caas_customer_po: is_caas_customer ? caas_customer_po : null,
  };
}
